<div class="user-access-add-popup-content" style="text-align: left; width: 100%;">

  <div class="d-flex justify-content-start align-items-center gap-4 m-0">
    <!-- Centered loader while fetching data -->
    <div *ngIf="showLoader" class="flex-grow-1 d-flex justify-content-center align-items-center">
      <app-loader></app-loader>
    </div>
    <!-- Dropdowns after loading -->
    <ng-container *ngIf="!showLoader">
        <div class="mb-3" style="min-width: 150px;">
      <label class="section-name tabl-header tabl-header-font">Role</label>
      <span class="d-block">{{ displayRole }}</span>
    </div>
    <ng-container *ngFor="let field of popupFields">
      <div class="mb-3">
        <label class="section-name tabl-header tabl-header-font">{{ field.label }}</label>
        <ng-container [ngSwitch]="field.type">          <ng-container *ngSwitchCase="'hierarchical'">
            <div *ngIf="getHierarchyData(field).length">
              <app-multiselect-group-checkbox
                [dropdowndataSource]="getHierarchyData(field)"
                [hierarchyDropdownConfig]="getHierarchyConfig(field)"
                [selectValues]="[]"
                [openAllPanel]="false"
                [placeholderText]="'Select ' + field.label"
                (selectedHierarchy)="onHierarchySelectionChange(field, $event)"
              ></app-multiselect-group-checkbox>
            </div>
          </ng-container>
          <ng-container *ngSwitchCase="'singleselect'">
            <div>
              <app-dropdown-with-search
                [Pixeltracking]="'false'"
                [showPlaceholder]="'false'"
                searchFlag="true"
                isMultiSelect="false"
                [dropdownData]="getFieldDropdownData(field)"
                [selected]="getFieldSelected(field)"
                (selectionChange)="onFieldSelectionChange(field, $event)"
              ></app-dropdown-with-search>
            </div>
          </ng-container>

          <ng-container *ngSwitchCase="'multiselect'">
            <div>
              <app-dropdown-with-search
                [Pixeltracking]="'false'"
                [showPlaceholder]="'false'"
                searchFlag="true"
                isMultiSelect="true"
                [dropdownData]="getFieldDropdownData(field)"
                [selected]="getFieldSelected(field)"
                [disableDD]="isFieldDisabled(field)"
                (selectionChange)="onFieldSelectionChange(field, $event)"
              ></app-dropdown-with-search>
            </div>
          </ng-container>

        </ng-container>
      </div>
    </ng-container>
    </ng-container>
  </div>

  <div class="form-footer d-flex justify-content-end" style="padding: 1rem 0 0; gap: 0.5rem;">
    <button
      *ngIf="popupFields.length > 0"
      mat-raised-button
      class="m-1 uitk-c-button uitk-c-button--default mat-mdc-raised-button techops-global-button"
      [disabled]="isSubmitDisabled"
      (click)="onSubmit()"
    >
      Submit
    </button>
    <button
      mat-raised-button
      class="m-1 uitk-c-button uitk-c-button--default mat-mdc-raised-button techops-global-button"
      (click)="onClose()"
    >
      Close
    </button>
  </div>
</div>
